import { render, staticRenderFns } from "./AppSearchData.vue?vue&type=template&id=18d62415&scoped=true&"
import script from "./AppSearchData.vue?vue&type=script&lang=js&"
export * from "./AppSearchData.vue?vue&type=script&lang=js&"
import style0 from "./AppSearchData.vue?vue&type=style&index=0&id=18d62415&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d62415",
  null
  
)

export default component.exports